let ctx;

export function audioCtx() {
  ctx ||= new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

// A short envelope on a gain node: silent, up to `peak` in `attack`, held, then gone by `end`.
export function env(g, t, peak, attack, end) {
  g.gain.setValueAtTime(0.0001, t);
  g.gain.exponentialRampToValueAtTime(peak, t + attack);
  g.gain.exponentialRampToValueAtTime(0.0001, t + end);
}

// One tone through its own envelope, into `out`.
export function tone(out, { type = "sine", freq, to, t, peak, attack = 0.01, end }) {
  const c = out.context, o = c.createOscillator(), g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, t);
  if (to) o.frequency.exponentialRampToValueAtTime(to, t + end);
  env(g, t, peak, attack, end);
  o.connect(g).connect(out);
  o.start(t);
  o.stop(t + end + 0.05);
}

const buffers = {};
// Two seconds of looping noise: white, or brown (deeper, like distant traffic).
export function noise(c, brown = false) {
  const k = brown ? "brown" : "white";
  if (buffers[k]) return buffers[k];
  const b = c.createBuffer(1, c.sampleRate * 2, c.sampleRate), d = b.getChannelData(0);
  let last = 0;
  for (let i = 0; i < d.length; i++) {
    const w = Math.random() * 2 - 1;
    d[i] = brown ? (last = (last + 0.02 * w) / 1.02) * 3.5 : w;
  }
  return (buffers[k] = b);
}

// A burst of filtered noise: crate rattles, crane clanks, waves breaking.
export function hiss(out, { t, freq, q = 1, peak, attack = 0.005, end, type = "bandpass" }) {
  const c = out.context, s = c.createBufferSource(), f = c.createBiquadFilter(), g = c.createGain();
  s.buffer = noise(c);
  f.type = type;
  f.frequency.value = freq;
  f.Q.value = q;
  env(g, t, peak, attack, end);
  s.connect(f).connect(g).connect(out);
  s.start(t, Math.random());
  s.stop(t + end + 0.05);
}
